import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const DocumentBIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 17 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M0.771429 0.771429V0C0.34538 0 0 0.34538 0 0.771429L0.771429 0.771429ZM0.771429 17.2286H0C0 17.6546 0.34538 18 0.771429 18L0.771429 17.2286ZM16.2 17.2286V18C16.626 18 16.9714 17.6546 16.9714 17.2286H16.2ZM11.5714 5.25974H10.8C10.8 5.68579 11.1454 6.03117 11.5714 6.03117V5.25974ZM11.5714 0.771429L12.1085 0.21762L11.884 0H11.5714V0.771429ZM16.2 5.25974H16.9714V4.93323L16.737 4.70593L16.2 5.25974ZM0.771429 0.771429H0V17.2286H0.771429H1.54286V0.771429H0.771429ZM0.771429 17.2286V18H16.2V17.2286V16.4571H0.771429V17.2286ZM11.5714 5.25974H12.3429V0.771429H11.5714H10.8V5.25974H11.5714ZM11.5714 0.771429V0H0.771429V0.771429V1.54286H11.5714V0.771429ZM16.2 17.2286H16.9714V5.25974H16.2H15.4286V17.2286H16.2ZM16.2 5.25974V4.48831H11.5714V5.25974V6.03117H16.2V5.25974ZM16.2 5.25974L16.737 4.70593L12.1085 0.21762L11.5714 0.771429L11.0344 1.32524L15.663 5.81355L16.2 5.25974ZM4.88622 9V9.77143H12.0862V9V8.22857H4.88622V9ZM4.88622 12.0857V12.8571H12.0862V12.0857V11.3143H4.88622V12.0857Z" fill={color} />
  </Svg>
);

DocumentBIcon.displayName = 'DocumentBIcon';
